class ConfirmationPopupController {
	constructor(popupService, appI18n) {
		'ngInject';
		this.srv = popupService;
		this.appI18n = appI18n;
		this.popupName = 'confirmation';
	}

	$onInit() {
		this.$API = this.srv.register(this.popupName);
		this.setButtons();
	}

	$onDestroy() {
		this.srv.unregister(this.popupName);
	}

	setButtons() {
		const self = this;
		const cancelPopupBtn = {
			action: () => {
				self.$API.hide({ answer: 'cancel' });

			},
			displayName: this.appI18n.translateImmediate('app.buttons.cancel'),
			cssClass: '-es-cancel', iconName: 'close', disabled: false
		};

		const submitPopupBtn = {
			action: () => {
				self.$API.hide({ answer: 'ok' });
			},
			displayName: this.appI18n.translateImmediate('app.buttons.ok'),
			cssClass: '-es-primary', disabled: false
		};

		this.btns = [cancelPopupBtn, submitPopupBtn];
	}
}

export default ConfirmationPopupController;
